import { useEmailSchema } from '@/common/hooks/schemas/useEmailSchema'
import { usePasswordSchema } from '@/common/hooks/schemas/usePasswordSchema'
import { usePhoneNumberSchema } from '@/common/hooks/schemas/usePhoneNumberSchema'
import { Seller_Type_Enum, SellerMemberAndItsSellerTypeFragment } from '@gql'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
type UseMemberSigninSchemaProps = {
  member?: SellerMemberAndItsSellerTypeFragment
}
export const useSellerMemberSigninSchema = ({
  member,
}: UseMemberSigninSchemaProps) => {
  const { t } = useTranslation()

  const { schema: passwordSchema } = usePasswordSchema()
  const { schema: emailSchema } = useEmailSchema()
  const { schema: phoneSchema } = usePhoneNumberSchema()

  const jobRequired =
    member?.seller?.type &&
    member?.seller?.type !== Seller_Type_Enum.NaturalPerson

  const schema = useMemo(
    () =>
      yup.object().shape({
        email: emailSchema.required(t('Forms.errors.required')),
        ['new-password']: passwordSchema.required(t('Forms.errors.required')),
        ['confirm-password']: passwordSchema
          .oneOf(
            [yup.ref('new-password'), undefined],
            t('Forms.errors.passwordMatch')
          )
          .required(t('Forms.errors.required')),
        phone: phoneSchema.required(t('Forms.errors.required')),
        job: jobRequired
          ? yup.string().required(t('Forms.errors.required'))
          : yup.string().optional(),
        terms: yup
          .boolean()
          .oneOf([true], t('Forms.errors.required'))
          .required(t('Forms.errors.required')),
      }),
    [t, emailSchema, phoneSchema, passwordSchema, jobRequired]
  )

  return { schema }
}

export type MemberSigninFormValues = yup.InferType<
  ReturnType<typeof useSellerMemberSigninSchema>['schema']
>
